import clsx from "clsx";
import { PropsWithChildren } from "react";
import styles from "../../../../components/card/rlcard.module.scss";
import NetworkLink from "./NetworkLink";

type Props = PropsWithChildren<{
  path: string;
  fragment?: string;
  className?: string;
  "data-testid"?: string;
}>;

const NetworkThreatHeaderLink: React.FC<Props> = ({
  path,
  fragment,
  className,
  children,
  "data-testid": dataTestId
}) => (
  <NetworkLink
    path={path}
    fragment={fragment}
    className={clsx(styles.header_link, className)}
    data-testid={dataTestId}
  >
    {children}
  </NetworkLink>
);

export default NetworkThreatHeaderLink;
